'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var coreRenderer = require('@tempi/core-renderer');

const MOBILE_WIDTH = 767;
const defaultMenu = [
  {
    id: "5eBqBWoa",
    name: "Trang ch\u1EE7",
    target: "SELF",
    isHidden: false,
    linkType: "PAGE",
    page: {
      id: 455,
      isHomepage: true,
      slug: null
    }
  },
  {
    id: "iCScxX63",
    name: "Blog",
    target: "BLANK",
    linkType: "PAGE",
    page: {
      id: 456,
      isHomepage: false,
      slug: "add-page-test"
    }
  },
  {
    id: "LvTwfsZx",
    name: "About",
    target: "BLANK",
    isHidden: true,
    linkType: "PAGE",
    page: {
      id: 458,
      slug: "test-122312",
      isHomepage: false
    }
  },
  {
    id: "7DWki3lv",
    name: "Services",
    target: "SELF",
    isHidden: false,
    linkType: "PAGE",
    page: {
      id: 419,
      slug: "test-add-page-3",
      isHomepage: false
    }
  },
  {
    id: "LebWjo9l",
    name: "Child1",
    linkType: "PAGE",
    parentId: "7DWki3lv",
    page: {
      id: 459,
      slug: "test-12123",
      isHomepage: false
    }
  },
  {
    id: "moar1sju",
    name: "Contact",
    target: "SELF",
    linkType: "PAGE",
    page: {
      id: 460,
      slug: "test-123123123",
      isHomepage: false
    }
  },
  {
    id: "aVtmfMh_",
    href: "https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",
    name: "Child2",
    target: "BLANK",
    linkType: "LINK",
    nofollow: true,
    parentId: "moar1sju"
  },
  {
    id: "IOm6L3zm",
    href: "https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",
    name: "Child3",
    target: "BLANK",
    linkType: "LINK",
    nofollow: true,
    parentId: "moar1sju"
  },
  {
    id: "Nuklf8V1",
    name: "Gallery",
    target: "SELF",
    linkType: "PAGE",
    page: {
      id: 454,
      slug: "test-qiwueqw-queqwe",
      isHomepage: false
    }
  },
  {
    id: "iR183_D0",
    href: "https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",
    name: "Child4",
    target: "BLANK",
    isHidden: true,
    linkType: "LINK",
    nofollow: true,
    parentId: "Nuklf8V1"
  },
  {
    id: "1hr5sQFD",
    href: "https://vnshop.vn/thung-48-bich-sua-tuoi-tiet-trung-khong-duong-dalatmilk-220ml--s210201486?sku=210201486",
    name: "Child5",
    target: "BLANK",
    linkType: "LINK",
    nofollow: true,
    parentId: "Nuklf8V1"
  },
  {
    id: "vx6PjNLA",
    name: "Lorem Ipsum",
    target: "SELF",
    isHidden: false,
    linkType: "PAGE",
    page: {
      id: 448,
      slug: "test-add-2",
      isHomepage: false
    }
  }
];
const DEFAULT_MENU = defaultMenu;
const DEFAULT_GLOBAL_HEADER = {
  stickyTop: true,
  menuConfig: {
    commonStyle: {
      columnGap: 32
    },
    align: coreRenderer.Alignment.right
  },
  logoConfig: {
    show: true,
    src: "https://tempi.vn/static/media/logo.2cc45380.png",
    align: coreRenderer.Alignment.left,
    commonStyle: {
      width: 100
    },
    spacingWithMenu: 32
  },
  menuItemConfig: {
    commonStyle: {
      color: "#000000",
      hover: {
        color: "#008cff"
      }
    }
  },
  commonStyle: {
    backgroundColor: "#ffffff",
    padding: {
      top: 30,
      right: 16,
      bottom: 30,
      left: 16
    }
  }
};

exports.DEFAULT_GLOBAL_HEADER = DEFAULT_GLOBAL_HEADER;
exports.DEFAULT_MENU = DEFAULT_MENU;
exports.MOBILE_WIDTH = MOBILE_WIDTH;
exports.defaultMenu = defaultMenu;
